<template>
  <div class="list">
    <p>{{fields[name].name}} <span>({{fileExtensions[name].join(', ')}})</span></p>
    <div class="load-image" :class="{invalid: fields[name].errorId}">
      <input :id="name" @change="processFile($event, name)" type="file" visibility="hidden">
      <template v-if="!isSelected">
        <icon-upload/>
        <span>Выбрать файл</span>
      </template>
      <template v-if="onUpload">
        <span class="file-load-label">Загрузка...</span>
        <v-progress-linear :indeterminate="true" height="5"
                           style="margin-bottom: 0; margin-top: -5px"></v-progress-linear>
      </template>
      <template v-if="useCase">
        <img v-if="isLoaded" :src="apiDomain + '/' + fields[name].value" @click="showModal = true"
             class="zoom-image" title="Увеличить картинку">
      </template>
      <template v-else>
        <img v-if="isLoaded" src="@/assets/file.png" alt="">
      </template>
<!--      <div class="info-file" v-if="isLoaded">-->
<!--        <span class="text">{{fields[name].fileName}}</span>-->
<!--      </div>-->
    </div>
    <div class="invalid_text">{{fields[name].errors[fields[name].errorId]}}</div>
    <transition name="fade">
      <div class="modal-image" @click.self="closeModal" v-if="showModal">
        <span class="close-icon" @click="closeModal"><icon-close/></span>
        <img :src="apiDomain + '/' + fields[name].value" v-show="showModal">
      </div>
    </transition>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import IconUpload from '../icons/IconUpload'
  import IconClose from '../icons/IconClose'

  const {mapMutations, mapState} = createNamespacedHelpers('mainPage')

  export default {
    props: ['name', 'types', 'useCase', 'uploadFront', 'folder'],
    data () {
      return {
        selectFile: 'Выбрать файл',
        isLoaded: false,
        isSelected: false,
        onUpload: false,
        showModal: false

      }
    },
    computed: {
      ...mapState([
        'fields',
        'currentTabId',
        'isError',
        'fileExtensions'
      ]),
      apiDomain () {
        return this.$store.state.apiDomain
      }
    },
    created() {
      if (this.fields[this.name].value) {
        this.isLoaded = true
        this.isSelected = true
      }
    },
    methods: {
      ...mapMutations([
        'setField',
        'checkFile'
      ]),
      closeModal () {
        this.showModal = false
      },
      onLoaded () {
        this.isLoaded = true
      },
      uploadFile (file) {
        this.isLoaded = false
        this.onUpload = true
        this.isSelected = true
        let data = new FormData()
        data.append('file', file)
        let useCase = ''
        this.useCase ? useCase = `?use_case=${this.useCase}` : useCase = ''
        let url;
        if (this.uploadFront === 'true') {
          url = '/api/uploadfile/front'
          data.append('folder', this.folder)
        } else {
          url = '/api/uploadfile' + useCase;
        }
        this.$http.post(url, data).then((response) => {
          this.onUpload = false
          this.isLoaded = true
          this.setField({fieldId: this.name, fieldPropertyId: 'value', value: response.data.url})
          this.setField({fieldId: this.name, fieldPropertyId: 'errorId', value: null})
          document.getElementById(this.name).value = ''
        }).catch(error => {
          document.getElementById(this.name).value = ''
          this.onUpload = false
          this.isLoaded = true
          this.setField({fieldId: this.name, fieldPropertyId: 'fileName', value: ''})
          this.$store.dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      },
      processFile (event) {
        let file = event.target.files[0]
        this.checkFile({name: this.name, fileName: file.name})
        if (!this.isError) {
          this.setField({fieldId: this.name, fieldPropertyId: 'fileName', value: file.name})
          this.uploadFile(event.target.files[0])
        }
      }
    },
    components: {
      IconClose,
      IconUpload
    }
  }
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .zoom-image {
    position: relative;
    z-index: 2;
    transition: 0.3s;
  }

  .zoom-image:hover {
    cursor: zoom-in !important;
    transform: scale(1.2);
    transition: 0.3s;
  }

  .load-image {
    overflow: hidden;
  }

  .modal-image {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    padding: 5%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);
    .close-icon {
      position: absolute;
      right: 20px;
      top: 20px;
      color: white;
      transition: 0.3s;
      svg {
        width: 18px;
        height: 18px;
      }
      &:hover {
        cursor: pointer;
        color: #089cd3;
        transition: 0.3s;
      }
    }
    img {
      margin: auto;
      max-height: 90%;
      max-width: 90%;
    }
  }

  .load-image .info-file {
    z-index: 5;
  }
</style>



// WEBPACK FOOTER //
// src/components/create-form/File.vue